import {
  Box,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import DefectWise from './components/dashboard/DefectWiseQty/DefectWiseQty';

const BreakDownAnalysisGraphTabs = () => {
  const annual_month = useQuery('annual_date') || '';
  const [tabValue, setTabValue] = useState(0);
  const [breakDowns, setBreakDowns] = useState<any>({});

  const fetchData = async () => {
    if (annual_month) {
      if (tabValue === 0) {
        const res = await axios
          .get(
            `/api/forMSummaryRoute/dashboard/getByTypeOfBreakDownMachineWise/?annualMonth=${annual_month}`
          )
          .catch((err) => {
            console.log(err);
          });
          setBreakDowns(res?.data);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [tabValue]);
  return (
    <Box>
      <ChildHeader text="BREAKDOWN ANALYSIS GRAPH"></ChildHeader>
      <Paper elevation={2}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(+newValue)}
          indicatorColor="primary"
          scrollButtons="auto"
          textColor="secondary"
          variant="fullWidth"
        >
         
          <Tab label="Monthly Breakdown" />
          
        </Tabs>
      </Paper>
      <section>
        {tabValue === 0 && breakDowns && breakDowns?.breakDownWise && (
          <DefectWise apiData={breakDowns?.breakDownWise} 
          title1="BREAKDOWN WISE PARETO ANALYSIS"
          title2="MACHINE WISE PARETO ANALYSIS"/>
        )}
      </section>
    </Box>
  );
};

export default BreakDownAnalysisGraphTabs;
